module.exports = __webpack_public_path__ + "static/media/mimi5.609127cb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/mimi5.gif
// module id = 297
// module chunks = 0